"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setLanguage = setLanguage;
exports.getLanguage = getLanguage;
const trans_1 = require("../../../../common/translations/trans");
function setLanguage(lang) {
    localStorage.setItem(trans_1.langKey, lang);
}
function getLanguage() {
    return localStorage.getItem(trans_1.langKey) || null;
}
